export default "__VITE_ASSET__BCGHovyZ__"